//Reference: EN012

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';

export class Sector extends Mappeable {
    idSectorPk: number;
    txtNombre: string;
    mrkActive: boolean;
    nmrVersion: number;
    dateVersion: string;
    dateInsert: string;
    userInsert: string;



    constructor(o) {
        super(o);
        this.dateInsert = moment(this.dateInsert, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.mrkActive = _.isUndefined(this.mrkActive) || _.isNull(this.mrkActive) ? false : this.mrkActive;
    }

    public mapToBack() {
        return {
            mrkActive: this.mrkActive,
            txtNombre: this.txtNombre
        }
    }
}
